import { isDirectoryItemFavorite } from './directory/isDirectoryItemFavorite/isDirectoryItemFavorite';
import { isDirectoryItemMatchForText } from './directory/isDirectoryItemMatchForText';
import { isDirectoryMatchForTags } from './directory/isDirectoryMatchForTags';

/**
 * Applies all the exhibitor filters kept in the store
 * @param {object} filter           Filter condition
 * @param {boolean} filter.favorites Only favorites exhibitors
 * @param {string} filter.text      Only exhibitors containing each word of the string (space separated)
 *
 * @param {object} exhibitor Exhibitor object
 * @returns boolean
 */
export function exhibitorsFilter(filter, exhibitor) {
    // Favorite check
    if (filter.favorites && !isDirectoryItemFavorite(exhibitor)) return false;

    // Check text
    if (filter.text && !isDirectoryItemMatchForText(filter.text, exhibitor)) return false;

    // Check tags
    if (filter.tags && !isDirectoryMatchForTags(filter.tags, exhibitor)) return false;

    // it passed all filters!
    return true;
}

/**
 * Returns true if the given filter contains filter conditions
 * @param {object} filter Filter params
 */
export function isExhibitorsFilterActive(filter) {
    if (!filter) return false;

    return (
        filter.favorites ||
        !!filter.text?.length ||
        (filter.tags && Object.keys(filter.tags).length)
    );
}


